<template>
  <div class="footer">
    <div class="set-position" style="width: 100%;max-width: 1200px;margin: 0 auto;">
      <div class="footer-left pull-left">
        <div>
             <p>主办单位：京投轨道交通科技控股有限公司 地址：北京市朝阳区惠新东街4号富盛大厦2座15层 邮编：100101</p>
             <p>版权所有：京投轨道交通科技控股有限公司 <a href="https://beian.miit.gov.cn" style="color:#FFFFFF;font-size=16px">京ICP备17044615号</a> <img src="static/imgs/logo1.png" alt=""> <a href="http://www.beian.gov.cn" style="color:#FFFFFF;font-size=16px">京公网安备11010502041908号</a></p>
        </div>
        <!--<div id="footer-logo">-->
          <!--<div><img src="static/imgs/c-bm.jpg" alt=""></div>-->
        <!--</div>-->
        <div>
         <!--  <p>用友网络科技股份有限公司 版权所有</p>
          <p>建议使用IE9.0以上浏览器 1366*768分辨率</p> -->
        </div>
      </div>
      <div class="footer-right pull-right">
        <div id="footer-phone">
          <div><img src="static/imgs/footer-phone.png" alt=""></div>
        </div>
        <div>
          <p>联系电话：{{telephone}}</p>
          <p>服务时间：{{servicetime}}</p>
         <!--  <p>电子邮件：liucca@yonyou.com</p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {apiLinks} from 'src/api/links'
  export default {
    data () {
      return {
        telephone: apiLinks.telephone,
        servicetime: apiLinks.servicetime
      }
    }
  }
</script>
<style>
  /*footer*/
  .footer {
    color: #F5F5F5;
    /*background-color: #5c5c5c;*/
    background-color: #4B5A6D;
    margin-top: 80px;
    font-size: 14px;
    overflow: hidden;
    padding-top: 20px;
  }

  .footer a {
    color: #bbbbbb;
  }

  .footer-left {
    //margin-top: 30px;
    margin-left: 10px;
  }

  .footer-right {
    /* margin-top: 20px; */
    margin-right: 10px;
  }

  .footer-left > div {
    display: inline-block;
  }

  .footer-right > div {
    display: inline-block;
  }

  #footer-logo {
    margin-right: 20px;
  }

  #footer-logo > div {
    width: 48px;
    height: 61px;
    overflow: hidden;
  }

  #footer-phone {
    margin-right: 20px;
  }

  #footer-phone > div img {
    position: relative;
    top: -17px;
  }

  #service-call {
    font-size: 20px;
  }

  .footer-right .name{
    margin-left: 75px;
  }

  .footer-right .call{
    font-size: 20px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// G-footer.vue?03832d14